module.exports = __webpack_public_path__ + "static/ContingentHero-dec0eabdce6429f9e3ea9befca15f9d9.png";